import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { UserContext } from "../../contexts/user";
import { get360Groups } from "../../axios/axiosFunctions";
import { Box, Container, Grid, Typography } from "@mui/material";
import bgImage from '../../assets/images/bgImage.png';
import GroupReportCard from "../../components/GroupReportCard";

const GroupsReport = () => {
    
    const {currentUser} = useContext(UserContext);
    const {slugAssessment} = useParams();
    const [groups, setGroups] = useState([]);
    
    useEffect(() => {
        const callGroups = async()=>{
            const res = await get360Groups(currentUser._id,slugAssessment);
            if(res){
                setGroups((res.groups || []).filter(g => g.group != null));
            }
        }
        callGroups();      
    }, [])

    return (
        <Container maxWidth="false" sx={{backgroundColor:"#e8f4f8",padding:"48px !important"}}>
             <Box display="flex" flexDirection="column">
                <Typography variant="h3" color="secondary">GROUPS</Typography>
                <Grid container spacing={2} sx={{marginTop:"40px"}}>
                {
                    groups.map((g,i)=>(
                        <Grid size={4} key={i}>
                            <GroupReportCard group={g.group} completed={g.completed} reviewerCount={g.user ? g.user.length : 0}/>
                        </Grid>
                    ))
                }
                </Grid>
             </Box>
        </Container>
    )
}

export default GroupsReport